import { resolveRouteAfterPaymentSuccess } from "@/features/payments/lib/after-payment-flow";

export const PAYMENT_STATUS_REFETCH_INTERVAL_MS = 30_000;

export type PendingPaymentCheckInput = {
  membershipStatus?: string | null;
  kycStatus?: string | null;
  kycAttemptStatus?: string | null;
};

export const isPendingMembershipPayment = (status?: string | null) =>
  status?.toUpperCase() === "PENDING";

export const resolveRouteAfterPendingPaymentCheck = ({
  membershipStatus,
  kycStatus,
  kycAttemptStatus,
}: PendingPaymentCheckInput) => {
  if (!membershipStatus) {
    return null;
  }

  if (isPendingMembershipPayment(membershipStatus)) {
    return null;
  }

  return resolveRouteAfterPaymentSuccess({
    membershipStatus,
    kycStatus,
    kycAttemptStatus,
  });
};
